import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Link } from 'react-router-dom';

// Import hooks
import { useAppSelector } from 'store/hooks';

// Import components
import { Button, ProgramRecordings } from 'components/elements';
import Share from './share/Share';
import { Reminder } from '../../common';

// Import utilities
import { useAuth } from 'components/utilities';

// Import helpers
import { sendChannelEvent } from 'helpers/tracking';
import { isRecordingsOperator } from 'helpers/operators';

// Import styles
import { Box, IconPlayStyled, ToolBox } from './styles';

const PopoverToolbox = ({
	reminderId,
	linkDetails,
	programId,
	isUpcoming = false,
	isCatchup = false,
	isNotEnded = false,
	theme,
	startDate,
	channelId
}) => {
	const channels = useAppSelector(({ channels }) => channels.data.lives);
	const channel = channels.find((channel) => channel.uuid === channelId);
	const isNpvrActive = channel?.context?.npvr_active && isNotEnded;
	const isChannelAvailable = channel?.avaiable;

	const { isAuth } = useAuth();

	const isRecordingEnabled = !!isNpvrActive;
	const isRecordingsPanelVisible = isRecordingEnabled && isAuth && isChannelAvailable && isRecordingsOperator;

	const handleButtonPlayClick = () => channel && sendChannelEvent({ url: linkDetails.pathname, genres: channel.genres, item_name: channel.title });

	const reminderProps = { reminderId, theme, programId, startDate };
	return (
		<ToolBox>
			<>
				{isUpcoming && isAuth && (
					<Box>
						<Reminder {...reminderProps} />
					</Box>
				)}
				{!isUpcoming && isAuth && (
					<Box isCatchup={isCatchup}>
						<Button as={Link} to={linkDetails} onClick={handleButtonPlayClick}>
							<IconPlayStyled />
						</Button>
					</Box>
				)}
				{isRecordingsPanelVisible && (
					<Box>
						<ProgramRecordings isNpvrActive={!!isNpvrActive} programId={programId} />
					</Box>
				)}
			</>

			<Box>
				<Share linkDetails={linkDetails} />
			</Box>
		</ToolBox>
	);
};

PopoverToolbox.propTypes = {
	isUpcoming: PropTypes.bool.isRequired,
	programId: PropTypes.string.isRequired,
	linkDetails: PropTypes.shape({
		pathname: PropTypes.string,
		state: PropTypes.shape({ sCatchup: PropTypes.bool }),
		hash: PropTypes.string
	}),
	reminderId: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([false])]),
	isCatchup: PropTypes.bool,
	isNotEnded: PropTypes.bool,
	startDate: PropTypes.string,
	channelId: PropTypes.string
};

export default withTheme(PopoverToolbox);
